import AudioPlayer from "@/component/AudioPlayer";
import AudioPlayerIns from "@/component/AudioPlayer/AudioPlayerIns";
import { Tab } from "@/constants/mobile";
import { DetailErrorType } from "@/constants/record";
import summaryCommonStore from "@/store/summaryCommon.store";
import { useEffect, useState, useRef } from "react";
import { useShallow } from "zustand/react/shallow";
import FILEDELETE from "../../assets/record/ic_file_delete.svg?react";
import DocComplete from "./DocComplete";
import SummaryPanel from "./SummaryPanel";
import TitleHeader from "@/sections/TitleHeader";
import TabList from "./TabList";
import VideoPlayer from "./VideoPlayer";
import avPlayerStore from "@/store/avPlayer.store";
import { VideoPlayerIns } from "./VideoPlayer/VideoPlayerIns";
import OriginTextAnchor from "@/component/OriginTextAnchor";
import summarySrcStore from '@/store/summarySrc.store';
let timer: NodeJS.Timeout;

const MobileSummary = ({ fromShare = false }: { fromShare?: boolean }) => {
  const { generatedTitle } = summarySrcStore.getState();

  const { audioInfo, shareInfo, errorStatus, audioScTimeList, videoLoadFailure, isOnlyOriginal } =
    summaryCommonStore(
      useShallow((state) => ({
        audioInfo: state.audioInfo,
        shareInfo: state.shareInfo,
        errorStatus: state.errorStatus,
        audioScTimeList: state.audioScTimeList,
        isOnlyOriginal: state.isOnlyOriginal,
        videoLoadFailure: state.videoLoadFailure,
      }))
    );

  const [activeTab, setActiveTab] = useState(isOnlyOriginal ? Tab.originalText : Tab.summary);
  // 添加触摸相关状态
  const isScrolling = useRef<boolean>(false);

  const onCurrentNumChange = (val: number) => {
    avPlayerStore.getState().updatePlayingTime(val);
  };

  const onIsPlayingChange = (isPlaying: boolean) => {
    avPlayerStore.getState().setIsAudioPlaying(isPlaying);
  };

  const onAudioInsLoaded = (audioIns: AudioPlayerIns) => {
    avPlayerStore.getState().setAudioPlayerIns(audioIns);
  };

  const onVideoInsLoaded = (videoIns: VideoPlayerIns) => {
    avPlayerStore.getState().setVideoPlayerIns(videoIns);
  };

  const handleScroll = () => {
    summaryCommonStore.getState().setIsScrolled(true);
    summaryCommonStore.getState().setIsFollowMode(true);
    timer && clearTimeout(timer);
    timer = setTimeout(() => {
      summaryCommonStore.getState().setIsFollowMode(false);
    }, 100);
  };

  const handleTouch = {
    onTouchStart: () => {
      isScrolling.current = true;
    },
    onTouchMove: () => {
      if (!isScrolling.current) return;
      // 处理滚动逻辑
      handleScroll();
    },
    onTouchEnd: () => {
      isScrolling.current = false;
    },
    onMouseDown: () => {
      isScrolling.current = true;
    },
    onMouseMove: () => {
      if (!isScrolling.current) return;
      // 处理滚动逻辑
      handleScroll();
    },
    onMouseLeave: () => {
      isScrolling.current = false;
    },
  };

  useEffect(() => {
    summaryCommonStore.getState().setIsMobile(true);
  }, []);

  return errorStatus && errorStatus === DetailErrorType.deleted ? (
    <div className="bg-#F2F3F5 h-full w-full flex flex-col mobile-page justify-center items-center">
      <FILEDELETE className="w-15 h-22"></FILEDELETE>
      <span className="text-#1F25334D text-size-4 mt-3.5">源文件已删除</span>
    </div>
  ) : (
    <div className="bg-#F2F3F5 h-full w-full flex flex-col mobile-page">
      {generatedTitle && <TitleHeader title={generatedTitle} />}
      {/* [旧版本不开录屏 || 新版本不开录屏] 有音频链接才显示播放器和Tab */}
      {(!audioInfo?.recordStatus && !audioInfo?.videoSrc && audioInfo?.audioSrc) ? (
        <div className="w-full h-38 bg-gradient-to-b from-#CCDCFD to-#F2F3F5 px-4 pt-4 pb-6">
          <AudioPlayer
            audioInfo={audioInfo}
            scTimeList={audioScTimeList}
            onIsPlayingChange={onIsPlayingChange}
            onCurrentNumChange={onCurrentNumChange}
            isMobile={true}
            onAudioInsLoaded={onAudioInsLoaded}
          />
          <div className="flex text-mx-tertiary mt-6 relative h-9 items-center">
            <TabList
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              fromShare={fromShare}
              isOnlyOriginal={isOnlyOriginal}
            />
          </div>
        </div>
      ) : null}
      {/* [旧版本开录屏 (recordStatus=null && videoSrc) || 新版本开录屏(recordStatus=true、videoSrc不一定)] */}
      {
        (audioInfo?.recordStatus || audioInfo?.videoSrc) && (
          <div>
            <VideoPlayer
              onVideoInsLoaded={onVideoInsLoaded}
              videoUrl={audioInfo?.videoSrc}
              videoLoadFailure={videoLoadFailure}
            />
            <div className="flex text-mx-tertiary mt-4 relative h-9 mx-4 items-center">
              <TabList activeTab={activeTab} setActiveTab={setActiveTab} fromShare={fromShare} isOnlyOriginal={isOnlyOriginal} />
            </div>
          </div>
        )
      }

      {/* 什么都没有的时候，显示tab */}
      {
        (!audioInfo?.recordStatus && !audioInfo?.videoSrc && !audioInfo?.audioSrc) && (
          <div className="flex text-mx-tertiary mt-4 relative h-9 mx-4 items-center">
            <TabList activeTab={activeTab} setActiveTab={setActiveTab} fromShare={fromShare} isOnlyOriginal={isOnlyOriginal} />
          </div>
        )
      }

      <div
        className={`flex-1 overflow-auto px-4 ${activeTab === Tab.originalText ? "pt-4" : ""
          } ${shareInfo ? "pb-37.5" : ""}`}
        {...handleTouch}
      >
        {activeTab === Tab.summary && <SummaryPanel isOnlyOriginal={isOnlyOriginal} fromShare={fromShare} />}
        {activeTab === Tab.originalText && <DocComplete />}
        {activeTab === Tab.originalText && (
          <OriginTextAnchor
            className="right-2 bottom-16.5"
            showToolTip={false}
          />
        )}
      </div>
    </div>
  );
};

export default MobileSummary;
